
 /**
 * Event `Map.ChangeView`
 *
 * @typedef {Object} MultSceneForApp~Map~Events~ChangeView
 * @property {string} type - type of event, has value `map.changeview`
 * @property {Array} center - center of map
 * @property {Number} resolution - resolution of map
 * @property {Number} rotation - rotation of map
 * @property {Number} zoom - zoom level of map
 */

export default function createEventChangeView(center, resolution, rotation, zoom) {
    return {
        type: 'map.changeview',
        center: center,
        resolution: resolution,
        rotation: rotation,
        zoom: zoom
    };
}
